import React from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useId } from 'react-id-generator';

import * as styles from './SideMenuBarScreen.module.scss';
import SideMenuItem from '../side-menu/SideMenuItem';
import { ReactComponent as Logo } from '../../assets/svg/logo.svg';
import { ReactComponent as LogoMini } from '../../assets/svg/icon_logo_mini.svg';
import SideMenuBarProps from './SideMenuBarProps';
import { navigationElements } from '../../../constants/navigationElements';
import { NavigationElement } from '../../vms/NavigationElement';

export default function SideMenuBarScreen(props: SideMenuBarProps) {
    const { expand, expandMenu } = props;
    const [id] = useId();

    return (
        <div
            className={classNames(
                styles.container,
                { [styles.collapse]: !expand },
                { [styles.expand]: expand }
            )}
        >
            <div
                className={classNames(
                    { [styles.logoContainer]: expand },
                    { [styles.logoMiniContainer]: !expand }
                )}
            >
                {expand && (
                    <Logo
                        className={classNames(
                            styles.logo,
                            { [styles.collapseLogo]: !expand },
                            { [styles.expandLogo]: expand }
                        )}
                    />
                )}
                {!expand && (
                    <LogoMini
                        className={classNames(
                            styles.logo,
                            { [styles.collapseLogo]: !expand },
                            { [styles.expandLogo]: expand }
                        )}
                    />
                )}
            </div>
            <nav className={styles.nav}>
                <ul className={classNames(styles.navItems, { [styles.navItemsCollapse]: !expand })}>
                    {navigationElements.map((item: NavigationElement, index: number) => (
                        <SideMenuItem
                            key={`${index}-${id}`}
                            item={item}
                            index={index}
                            expandMenu={expand}
                        />
                    ))}
                </ul>
            </nav>
            <div
                className={styles.arrowContainer}
                onClick={() => (expandMenu ? expandMenu(!expand) : {})}
            >
                <FontAwesomeIcon
                    icon={expand ? 'angle-double-left' : 'angle-double-right'}
                    className={styles.arrow}
                />
            </div>
        </div>
    );
}
